import Chart from "../Chart/Chart"

const ExpensesChart = (props) => {
    const chartDataPoints = Array.from({ length: 12 }, (_, monthIndex) => {
        const monthLabel = (monthIndex + 1).toString().padStart(2, '0'); // Format month as '01', '02', ...
        const expensesForMonth = props.expenses.filter((expense) => {
          return expense.date.getMonth() + 1 === monthIndex + 1; // Month is zero-based
        });
        const totalExpenseForMonth = expensesForMonth.reduce(
          (sum, expense) => sum + expense.amount,
          0
        );
        return { label: monthLabel, value: totalExpenseForMonth };
      });
      

for(const expense of props.expenses){
    const expenseMonth = expense.date.getMonth()
    chartDataPoints[expenseMonth].value += expense.amount 
}

return <Chart dataPoints = {chartDataPoints} />
}

export default ExpensesChart